import { useEffect, useState } from "react";
const admin_service = require("../helpers/admin_service");
export default function useInfo() {
  const [encabezado, setEncabezado] = useState(null);
  const [congresos, setCongresos] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async function () {
      try {
        setLoading(true);
        admin_service
          .getData("/encabezado-congresos/get-last")
          .then((data) => {
            admin_service
              .getData("/evento/congresos")
              .then((response) => {
                setEncabezado(data.data.response.result);
                setCongresos(response.data.response_database.result);
              })
              .catch((error) => {
                console.log(error);
              });
          })
          .catch((err) => {
            console.log(err);
          });
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return { encabezado, congresos, error, loading };
}
